import script from "./VitaMobileScreen.vue?vue&type=script&setup=true&lang=ts"
export * from "./VitaMobileScreen.vue?vue&type=script&setup=true&lang=ts"

import "./VitaMobileScreen.vue?vue&type=style&index=0&id=bf8e20a8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf8e20a8"]])

export default __exports__